import React from "react";
import ReactDOM from "react-dom";

const ModalFull = ({
  children,
  style = {},
  className = "",
  close,
  zIndex = 1,
  hideCloseBtn = false,
}) => {
  const element = (
    <div
      className="uk-modal-full uk-flex uk-open uk-background-default"
      uk-modal="stack: true"
      style={zIndex ? { zIndex } : {}}
    >
      <div
        className={[className, "uk-modal-dialog uk-text-center"].join(" ")}
        style={style}
      >
        {hideCloseBtn ? null : (
          <button
            className="uk-modal-close-full uk-close-large"
            type="button"
            onClick={close}
            uk-close={1}
          ></button>
        )}
        <div className="uk-container-expand uk-height-1-1 uk-flex uk-flex-center uk-child-width-expand">
          {children}
        </div>

        {/* <div className="uk-grid-collapse uk-child-width-1-2@s uk-flex-middle" uk-grid={1}>
        </div> */}
      </div>
    </div>
  );

  return ReactDOM.createPortal(element, document.body);
};

export default ModalFull;
